import _ceil from "lodash/ceil";

export const roundUp = (number: number, precision?: number) => {
  // To display coherent prices, we need to round up the price to the next integer (to the next cent up)
  // for example, 100.004 = 1,004€ will be displayed as 1,01€.
  // We round up to make sure that the price displayed is always superior or equal and never inferior to the price calculated.

  return _ceil(number, precision || 0);
};
